const SECONDS = 1000;
const MINUTES = 60 * SECONDS;
export const TIMEOUTS = {
  maxOfflineTime: 30 * SECONDS,
  maxWaitForSync: 1 * MINUTES,
  maxWaitForServerMessage: 30 * SECONDS,
  maxWebsocketOpen: 4 * MINUTES,
  connectTimeout: 5 * SECONDS,
  retryFactor: 2,
  retryMaxDelay: 10 * SECONDS,
  retryMinDelay: 0,
  retryDelay: 400,
  retryMaxAttempts: 0,
  retryInitialDelay: 200,
  versionIdMissingCheck: 2 * SECONDS,
};

export const CE_ERROR = 'CE_ERROR';

// hocuspocus lifecycle
export const CE_COLLABORATION_WEB_SOCKET_CREATED = 'CE_COLLABORATION_WEB_SOCKET_CREATED';
export const CE_CONNECT_INITIATED = 'CE_CONNECT_INITIATED';
export const CE_CONNECTION_ATTEMPT = 'CE_CONNECTION_ATTEMPT';
export const CE_OPEN = 'CE_OPEN';
export const CE_CONNECT = 'CE_CONNECT';
export const CE_AUTHENTICATED = 'CE_AUTHENTICATED';
export const CE_AUTHENTICATION_FAILED = 'CE_AUTHENTICATION_FAILED';
export const CE_STATUS = 'CE_STATUS';
export const CE_MESSAGE = 'CE_MESSAGE';
export const CE_OUTGOING_MESSAGE = 'CE_OUTGOING_MESSAGE';
export const CE_NEW_SERVER_STATE = 'CE_NEW_SERVER_STATE';
export const CE_CLOSE = 'CE_CLOSE';
export const CE_DISCONNECT = 'CE_DISCONNECT';
export const CE_DESTROY = 'CE_DESTROY';
export const CE_AWARENESS_CHANGE = 'CE_AWARENESS_CHANGE';
export const CE_STATELESS = 'CE_STATELESS';
export const CE_CONNECT_STARTED = 'CE_CONNECT_STARTED';
export const CE_UNSYNCED_CHANGES = 'CE_UNSYNCED_CHANGES';
export const CE_NEW_LOCK_STATE = 'CE_NEW_LOCK_STATE';

// diff synchronizer lifecycle
export const CE_DIFF_SYNCHRONIZER_CREATED = 'CE_DIFF_SYNCHRONIZER_CREATED';
export const CE_LOCAL_UPDATED_BEGIN = 'CE_LOCAL_UPDATED_BEGIN';
export const CE_SYNC_DISCONNECT = 'CE_SYNC_DISCONNECT';
export const CE_FROM_DISCONNECT_SYNC_BEGIN = 'CE_FROM_DISCONNECT_SYNC_BEGIN';
export const CE_NEW_STATE = 'CE_NEW_STATE';
export const CE_STATUS_MODIFICATION_EXCEPTION = 'CE_STATUS_MODIFICATION_EXCEPTION';

// collaboration worker lifecycle
// CW_STATE_CHANGE is called when the server has a new state (caused by either local or remote change)
export const CW_STATE_CHANGE = 'CW_STATE_CHANGE';
// CW_AWARENESS_UPDATE is called when the awareness state has been updated
export const CW_AWARENESS_UPDATE = 'CW_AWARENESS_UPDATE';
// CW_NETWORK_STATUS_ERROR is fired when a recoverable error has occured
export const CW_NETWORK_STATUS_ERROR = 'CW_NETWORK_STATUS_ERROR';
// CW_NETWORK_STATUS_CONNECTED is fired when we have recieved data from the server
export const CW_NETWORK_STATUS_CONNECTED = 'CW_NETWORK_STATUS_CONNECTED';
// CW_NETWORK_STATUS_ABORT is fired when a non-recoverable error has occurred
export const CW_NETWORK_STATUS_ABORT = 'CW_NETWORK_STATUS_ABORT';
// CW_STATUS_MODIFICATION_EXCEPTION is fired when the status changes from what was expected
export const CW_STATUS_MODIFICATION_EXCEPTION = 'CW_STATUS_MODIFICATION_EXCEPTION';
// CW_STATUS_CHANGED is fired from the client that updated the status
export const CW_STATUS_CHANGED = 'CW_STATUS_CHANGED';
// CW_STATUS_CHANGED_BROADCAST is fired from the server to everyone when it gets a CW_STATUS_CHANGED
export const CW_STATUS_CHANGED_BROADCAST = 'CW_STATUS_CHANGED_BROADCAST';
// CW_VERSION_REQUEST is sent when we initially connect and do not have a version id, to request the version id
export const CW_VERSION_REQUEST = 'CW_VERSION_REQUEST';
// CW_VERSION_CHANGED_BROADCAST is fired from the server when a version number has been updated
export const CW_VERSION_CHANGED_BROADCAST = 'CW_VERSION_CHANGED_BROADCAST';
// CW_LOCK_CHANGE is called when lock data has changed
export const CW_LOCK_CHANGE = 'CW_LOCK_CHANGE';
// CW_SUBMISSION_LOCK is fired upon user request for lock
export const CW_SUBMISSION_LOCK = 'CW_SUBMISSION_LOCK';
// CW_SUBMISSION_UNLOCK is fired upon user request for unlock
export const CW_SUBMISSION_UNLOCK = 'CW_SUBMISSION_UNLOCK';

export const CW_FORCE_RELOAD = 'CW_FORCE_RELOAD';
